export default "__VITE_ASSET__f77607f4__"